/**
 * Created by fers on 19/03/2017.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';
import Relay from 'react-relay';
import SearchActionExpressionEditor from './SearchActionExpressionEditor.react';
import {LoadingLine} from '../../loadingLine/renderLoadingPanel.react';
import DataSourceDecorationEdit from './DataSourceDecorationEdit.react';
import {safeJSONparse} from "../../../common/util/safeJSONparse";

export function prepareArgs(actionDef, mapping) {
    return {
        mapping: mapping,
        datiQuery: actionDef.useForDatiQuery === true && actionDef.actionInputDefs.edges.findIndex(({node}) => !node['fieldDef_id']) === -1,
    };
}

class DataSourceSearchActionEdit extends React.Component {
    static propTypes = {
        apply: PropTypes.func,
        children: PropTypes.any,
        dataSource: PropTypes.object.isRequired,
        goBack: PropTypes.func,
        intl: PropTypes.object,
        relay: PropTypes.object,
    };

    constructor(props) {
        super(props);
    }

    add = (mapping) => {
        let args = safeJSONparse(this.props.dataSource.args);
        let actionDef = this.props.dataSource.channels[0].channelDef.actionDef;

        args = {
            ...args,
            ...prepareArgs(actionDef, mapping)
        };

        let newDataSource = {
            id: this.props.dataSource.id,
            args: args
        };

        return this.props.apply(newDataSource);
    };

    render() {
        let dataSource = this.props.dataSource;
        let relatedActionDefs = this.props.dataSource.relatedActionDefs;

        let args = safeJSONparse(dataSource.args);

        return (
            <DataSourceDecorationEdit
                dataSource={dataSource}
                goBack={this.props.goBack}
            >

            {relatedActionDefs && relatedActionDefs.length > 0 ?
                <div style={{width: '100%', padding: '2em'}}>
                    <SearchActionExpressionEditor actionDef={relatedActionDefs[0]} dataSource={dataSource} intl={this.props.intl} mapping={args.mapping} parentDataSource={dataSource.relativeTo} save={this.add} />
                </div>
                :
                <LoadingLine />
            }
            </DataSourceDecorationEdit>
        );
    }
}

export default Relay.createContainer(injectIntl(DataSourceSearchActionEdit), {
    initialVariables: {
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        dataSource: () => {
            return Relay.QL`
                fragment on DataSource {
                    id,
                    realId,
                    typeId,
                    name,
                    description,
                    idx,
                    args,
                    ${DataSourceDecorationEdit.getFragment('dataSource')},
                    relativeTo {
                        id,
                        realId,
                        mappedFields {
                            id,
                            realId,
                            name,
                            key,
                            type,
                            shortName,
                            entityDef {
                                id,
                                realId,
                                name,
                                key
                            }
                        },
                    },
                    relatedActionDefs {
                        id,
                        realId,
                        name,
                        actionInputDefs(first: 1000) {
                            edges {
                                node {
                                    id,
                                    realId,
                                    key,
                                    name,
                                    type,
                                    entityDef_id,
                                    fieldDef_id,
                                    entityDef {
                                        id,
                                        name,
                                    },
                                    fieldDef {
                                        id,
                                        name
                                    }
                                }
                            }
                        }
                    },
                    channels {
                        id,
                        realId,
                        channelDef {
                            id,
                            realId,
                            name,
                        },
                    }
                }`;
        }
    }
});
